import React from 'react';
import styled from 'styled-components/macro';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';

export function WaiverTable(props) {
  const { t } = useTranslation();
  const rows = props.contractLineData ?? [];

  return (
    <Wrapper>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size='small'>
          <TableHead>
            <TableRow>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.contractLineID)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.invoiceNumber)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.changeType)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.currency)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.totalPrice)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.waiveAmount)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.periodFrom)}
              </TableCell>
              <TableCell align='center' className='table-header'>
                {t(translations.contractDetail.amendment.waiver.periodTo)}
              </TableCell>
            </TableRow>
          </TableHead>
          {rows.length > 0 && (
            <TableBody>
              {rows.map(row => (
                <TableRow
                  key={row.contractLineId}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align='center'>{row.contractLineId}</TableCell>
                  <TableCell align='center'>{row.invoiceNumber}</TableCell>
                  <TableCell align='center'>{row.chargeType}</TableCell>
                  <TableCell align='center'>{row.contractCurrency}</TableCell>
                  <TableCell align='center'>{(row.totalPrice ?? 0).toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  })}</TableCell>
                  <TableCell align='center'>{(row.waiveAmount ?? row.waiverAmount ?? 0).toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                  })}</TableCell>
                  <TableCell align='center'>{row.waiverPeriodFrom}</TableCell>
                  <TableCell align='center'>{row.waiverPeriodTo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  margin-top: 5px;

  .table-header {
    background: ${p => p.theme.primary};
    color: ${p => p.theme.background};
  }

  .MuiTableCell-root {
    font-size: 12px;
    padding: 2px;
    line-height: 15px;
    border-right: 1px solid rgba(224, 224, 224, 1) !important;
    width: 100px;
  }
`;
